import PageTitle from "../../components/PageTitle";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import PageContent from "../../components/PageContent";
import useApi from "../../hooks/ApiHook";
import { useEffect, useState } from "react";
import If from "../../components/If";
import Loading from "../../components/Loading";
import usePaginator from "../../hooks/PaginatorHook";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Tag } from "primereact/tag";
import OrderDetailSidebar from "./OrderDetailSidebar";

import useToast from "../../hooks/ToastHook";
import OrderNfeSidebar from "./OrderNfeSidebar";

const currencyIntl = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' });

const statusTags = {
    WAITING: <Tag severity="warning" value="AGUARDANDO"/>,
    ACCEPTED: <Tag severity="success" value="APROVADO"/>,
    CANCELED: <Tag severity="danger" value="CANCELADO"/>,
    FAILED: <Tag severity="danger" value="FALHA"/>,
    REJECTED: <Tag severity="info" value="REJEITADO"/>
}

export default function Orders() {
    const api = useApi();
    const navigate = useNavigate();
    const toast = useToast();
    const [ orders, setOrders ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const { page, limit, setTotal, Paginator } = usePaginator();
    const [ searchParams, setSearchParams ] = useSearchParams();
    const [ selectedDetails, setSelectedDetails ] = useState();
    const [ selectedNfeList, setSelectedNfeList ] = useState();
    
    useEffect(() => {
        retrieveData();
    }, [page, limit]);

    const retrieveData = () => {
        setLoading(true);
        api.get(`orders?page=${page}&limit=${limit}`).then(({ data }) => {
            setOrders(data.data);
            setTotal(data.total);
            setSearchParams({ page, limit });
        }).finally(() => setLoading(false));
    }

    // const invoice = order => {
    //     const putInvoice = () => api
    //         .put(`orders/${order.id}`, { invoiced: true })
    //         .then(() => toast.showSuccess('Nota faturada com sucesso'))
    //         .finally(retrieveData)
    //     confirmDialog({
    //         message: 'Deseja marcar esse pedido como faturado?',
    //         header: 'Atenção',
    //         icon: 'pi pi-info-circle',
    //         acceptLabel: 'Sim',
    //         rejectLabel: 'Não',
    //         accept: putInvoice
    //     })
    // }

    const actions = order => {

        const showNewSale = order.status === 'WAITING' || order.status === 'FAILED';
        const showNfeList = order?.nfeList?.length > 0;
        const nfeButtonSeverity = order.status === 'FAILED' ? 'danger' : 'primary';

        return (
            <>
                {showNewSale && (
                    <Button icon="pi pi-shopping-cart" className="ml-2" title="Nova venda" onClick={() => {
                        navigate(`/new-sale/${order.id}`);
                    }}/>
                )}
                {showNfeList && (
                    <Button icon="pi pi-file" severity={nfeButtonSeverity} className="ml-2" title="List de NFe" onClick={() => {
                        setSelectedNfeList(order);
                    }}/>
                )}
                <Button icon="pi pi-eye" className="ml-2" title="Visualizar" onClick={() => setSelectedDetails(order)}/>
            </>
        );
    };

    const statusColumnBody = order => statusTags[order.status];

    return (
        <div>
            {/* <MovementDetailSidebar movementId={selected?.id} onHide={() => setSelected(undefined)}/> */}
            <PageTitle title="Pedidos" subtitle="Pedidos realizados pelos distribuidores"/>
            <PageContent>
                <If condition={loading}>
                    <Loading/>
                </If>
                <If condition={!loading}>
                    <DataTable value={orders} selectionMode="single" emptyMessage="Nada encontrado">
                        <Column field="client.commercialName" header="Destino"></Column>
                        <Column field={m => m.items.length} header="Produtos"></Column>
                        <Column field={m => new Date(m.createdAt).toLocaleString()} header="Data/hora"></Column>
                        <Column body={statusColumnBody} header="Status"/>
                        <Column body={actions} header="Ações" align='right'></Column>
                    </DataTable>
                    <Paginator/>
                </If>
            </PageContent>
            <OrderDetailSidebar order={selectedDetails} onHide={() => setSelectedDetails(null)}/>
            <OrderNfeSidebar order={selectedNfeList} onHide={() => setSelectedNfeList(null)} onChange={retrieveData}/>
        </div>
    );
}